<template>
  <div id="weight-vol-calc-comp" class="clearfix">
    <div class="clearfix lift">
      <header class="weight-head">
        <h5>Weight/Volume Calculator</h5>
        <div class="weight-close" @click="$emit('weight-close')">
          <i class="fa fa-check"></i>
        </div>
      </header>
      <section class="singles clearfix">
        <div class="col-xs-12 col-sm-4">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon" data-toggle="tooltip" title="Density">
                D
              </span>
              <input type="number" class="form-control" id="density" v-model="density" @change="densityChange"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon" data-toggle="tooltip" title="Net-to-Gross">
                NtG
              </span>
              <input type="number" class="form-control" id="net-to-gross" v-model="netToGross" @change="netToGrossChange"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-4">
          <div class="form-group">
            <div class="input-group">
              <span class="input-group-addon" data-toggle="tooltip" title="ACW">
                ACW
              </span>
              <input type="number" class="form-control" id="acw" v-model="ACW" @change="acwChange"/>
            </div>
          </div>
        </div>
      </section>
      <section class="groups clearfix">
        <div class="">
          <div class="col-xs-12 col-sm-6 card card-first-child">
            <hr class="hr-text" data-content="NET">
            <div class="col-xs-12 col-md-6 no-pad">
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Lbs
                    </span>
                    <input type="number" class="form-control" id="net-lbs" v-model="weightLbs.net" @change="weightLbsNetChange"/>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Cb.Ft
                    </span>
                    <input type="number" class="form-control" id="net-cft" v-model="cubicFt.net" @change="cubicFtNetChange"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 no-pad">
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Kg
                    </span>
                    <input type="number" class="form-control" id="net-kg" v-model="weightKgs.net" @change="weightKgNetChange"/>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Cb.M
                    </span>
                    <input type="number" class="form-control" id="net-cm" v-model="cubicM.net" @change="cubicMNetChange"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="">
          <div class="col-xs-12 col-sm-6 card">
            <hr class="hr-text" data-content="GROSS"/>
            <div class="col-xs-12 col-md-6 no-pad">
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Lbs
                    </span>
                    <input type="number" class="form-control" id="gross-lbs" v-model="weightLbs.gross" @change="weightLbsGrossChange"/>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Cb.Ft
                    </span>
                    <input type="number" class="form-control" id="gross-cft" v-model="cubicFt.gross" @change="cubicFtGrossChange"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-6 no-pad">
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Kg
                    </span>
                    <input type="number" class="form-control" id="gross-kg" v-model="weightKgs.gross" @change="weightKgsGrossChange"/>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 no-pad">
                <div class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">
                      Cb.M
                    </span>
                    <input type="number" class="form-control" id="gross-cm" v-model="cubicM.gross" @change="cubicMGrossChange"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'WeightVolumeCalculator',
    props: [
      'd',
      'ntg',
      'lbs',
      'kgs',
      'cubFt',
      'cubM',
      'acw',
      'canEmit',
      'quote'
    ],
    data () {
      return {
        density: 0,
        netToGross: 0,
        weightLbs: {
          gross: 0,
          net: 0
        },
        weightKgs: {
          gross: 0,
          net: 0
        },
        cubicFt: {
          gross: 0,
          net: 0
        },
        cubicM: {
          gross: 0,
          net: 0
        },
        ACW: 0
      }
    },
    watch: {
      canEmit (newVal) {
        if (newVal) {
          this.initialiseFromQuote()
        }
      },
      allData (newVal, oldVal) {
        if (this.canEmit) {
          this.$store.dispatch('quote/metricsChange', JSON.parse(newVal))
        }
      },
      'weightLbs.net' (newVal, oldVal) {
        if (this.canEmit && newVal && parseFloat(newVal) !== oldVal) {
          this.$emit('data-change', (newVal === '0.000' ? '0' : newVal))
        }
      },
      d (newVal, oldVal) {
        if (this.density !== newVal && this.canEmit) {
          this.density = newVal
        }
      },
      ntg (newVal, oldVal) {
        if (this.netToGross !== newVal && this.canEmit) {
          this.netToGross = newVal
        }
      },
      lbs (newVal, oldVal) {
        if (this.weightLbs.net !== newVal && this.canEmit) {
          this.weightLbs.net = parseFloat(newVal).toFixed(0)
        }
      },
      kgs (newVal, oldVal) { if (this.weightKgs.net !== newVal && this.canEmit) { this.weightKgs.net = newVal } },
      cubFt (newVal, oldVal) { if (this.cubicFt.net !== newVal && this.canEmit) { this.cubicFt.net = newVal.toFixed(0) } },
      cubM (newVal, oldVal) { if (this.cubicM.net !== newVal && this.canEmit) { this.cubicM.net = newVal } },
      acw (newVal, oldVal) {}
    },
    methods: {
      setValue (prop, value) {
        this[prop] = value
      },
      initialiseFromQuote () {
        if (this.quote && this.quote.wgtNetLbs) {
          this.weightLbs.net = this.quote.wgtNetLbs
          this.weightLbs.gross = this.quote.wgtGrsLbs
          this.weightKgs.gross = this.quote.wgtGrsKgs
          this.weightKgs.net = this.quote.wgtNetKgs
          this.cubicFt.gross = this.quote.volGrsCuf
          this.cubicFt.net = this.quote.volNetCuf
          this.cubicM.gross = this.quote.volGrsM3
          this.cubicM.net = this.quote.volNetM3
          this.ACW = this.quote.acwGrsKgs
        }
      },
      calcWeightFromAcw () {
        return parseFloat(((this.ACW / 10.4) * this.density).toFixed(3))
      },
      densityChange () {
        if (this.canEmit) {
          this.weightLbsNetChange()
        }
      },
      netToGrossChange () {
        if (this.canEmit) {
          this.cubicFt.gross = this.convertToGross(this.cubicFt.net).toFixed(0)
          this.cubicFtGrossChange()
        }
      },
      weightLbsGrossChange () {
        if (this.canEmit) {
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.weightKgs.gross = this.convertFrom('LBS', this.weightLbs.gross)
          this.weightKgs.net = this.convertToNet(this.weightKgs.gross)
          this.cubicFt.gross = this.crossConvertFrom('LBS', this.weightLbs.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.ACW = this.calcACW()
        }
      },
      weightLbsNetChange () {
        if (this.canEmit) {
          this.weightKgs.net = this.convertFrom('LBS', this.weightLbs.net)
          this.weightLbs.gross = this.convertToGross(this.weightLbs.net).toFixed(0)
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.cubicFt.net = this.crossConvertFrom('LBS', this.weightLbs.net).toFixed(0)
          this.cubicFt.gross = this.convertToGross(this.cubicFt.net).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.ACW = this.calcACW()
        }
      },
      weightKgsGrossChange () {
        if (this.canEmit) {
          this.weightKgs.net = this.convertToNet(this.weightKgs.gross)
          this.weightLbs.gross = this.convertFrom('KG', this.weightKgs.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.cubicFt.gross = this.crossConvertFrom('LBS', this.weightLbs.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.ACW = this.calcACW()
        }
      },
      acwChange () {
        if (this.canEmit) {
          this.weightKgs.gross = this.calcWeightFromAcw()
          this.weightKgs.net = this.convertToNet(this.weightKgs.gross)
          this.weightLbs.gross = this.convertFrom('KG', this.weightKgs.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.cubicFt.gross = this.crossConvertFrom('LBS', this.weightLbs.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
        }
      },
      weightKgNetChange () {
        if (this.canEmit) {
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.weightLbs.gross = this.convertFrom('KG', this.weightKgs.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.cubicFt.gross = this.crossConvertFrom('LBS', this.weightLbs.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.ACW = this.calcACW()
        }
      },
      cubicFtNetChange () {
        if (this.canEmit) {
          this.cubicFt.gross = this.convertToGross(this.cubicFt.net).toFixed(0)
          this.cubicM.net = this.convertFrom('CUFT', this.cubicFt.net)
          this.cubicM.gross = this.convertToGross(this.cubicM.net)
          this.weightLbs.net = this.crossConvertFrom('CUFT', this.cubicFt.net).toFixed(0)
          this.weightLbs.gross = this.convertToGross(this.weightLbs.net).toFixed(0)
          this.weightKgs.net = this.convertFrom('LBS', this.weightLbs.net)
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.ACW = this.calcACW()
        }
      },
      cubicFtGrossChange () {
        if (this.canEmit) {
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.cubicM.gross = this.convertFrom('CUFT', this.cubicFt.gross)
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.weightLbs.gross = this.crossConvertFrom('CUFT', this.cubicFt.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.weightKgs.net = this.convertFrom('LBS', this.weightLbs.net)
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.ACW = this.calcACW()
        }
      },
      cubicMGrossChange () {
        if (this.canEmit) {
          this.cubicM.net = this.convertToNet(this.cubicM.gross)
          this.cubicFt.gross = this.convertFrom('M3', this.cubicM.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.weightLbs.gross = this.crossConvertFrom('CUFT', this.cubicFt.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.weightKgs.net = this.convertFrom('LBS', this.weightLbs.net)
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.ACW = this.calcACW()
        }
      },
      cubicMNetChange () {
        if (this.canEmit) {
          this.cubicM.gross = this.convertToGross(this.cubicM.net)
          this.cubicFt.gross = this.convertFrom('M3', this.cubicM.gross).toFixed(0)
          this.cubicFt.net = this.convertToNet(this.cubicFt.gross).toFixed(0)
          this.weightLbs.gross = this.crossConvertFrom('CUFT', this.cubicFt.gross).toFixed(0)
          this.weightLbs.net = this.convertToNet(this.weightLbs.gross).toFixed(0)
          this.weightKgs.net = this.convertFrom('LBS', this.weightLbs.net)
          this.weightKgs.gross = this.convertToGross(this.weightKgs.net)
          this.ACW = this.calcACW()
        }
      },
      /* */
      updateAllValues () {},
      updateWeightLbsGross () {},
      updateWeightLbsNet () {},
      updateWeightKgsGross () {},
      updateWeightKgsNet () {},
      updateCubicFtGross () {},
      updateCubicFtNet () {},
      updateCubicMGross () {},
      updateCubicMNet () {},
      updateAcw () {},
      /* */
      convertToNet (val) {
        return parseFloat((val / this.convertUnit).toFixed(3))
      },
      convertToGross (val) {
        return parseFloat((val * this.convertUnit).toFixed(3))
      },
      convertFrom (fromUnit, fromValue) {
        let fn = null
        switch (fromUnit) {
          case 'KG':
            fn = val => val * 2.204623
            break
          case 'LBS':
            fn = val => val / 2.204623
            break
          case 'CUFT':
            fn = val => val / 35.3128126
            break
          case 'M3':
            fn = val => val * 35.3128126
            break
        }
        return parseFloat(fn(fromValue).toFixed(3))
      },
      crossConvertFrom (fromUnit, fromValue) {
        let fn = null
        let d = this.density
        switch (fromUnit) {
          // LBS TO CUBIC FEET
          case 'LBS':
            fn = val => val / d
            break
          // CUFT to LBS
          case 'CUFT':
            fn = val => val * d
            break
        }
        return parseFloat(fn(fromValue).toFixed(3))
      },
      calcACW () {
        return parseFloat(((this.weightKgs.gross / this.density) * 10.4).toFixed(3))
      }
    },
    computed: {
      convertUnit () {
        return (1 + (this.netToGross / 100))
      },
      allData () {
        return JSON.stringify(this.$data)
      }
    },
    mounted () {}
  }
</script>
<style scoped>
  .lift {
    background-color: #eee;
    margin: 35px 10px;
  }
  .lift h5 {
    margin: 0 !important;
    display: inline-block;
  }
  .no-pad {
    padding: 0 !important;
  }
  @media (max-width: 767px) {
    .groups .card-first-child {
      margin-bottom: 20px;
    }
  }
  .weight-head {
    padding: 30px 55px;
    color: #fff;
    background-color: #3c8dbc;
  }
  .weight-close {
    display: inline-block;
    float: right;
  }
  .singles {
    background-color: #fff;
    color: #949292;
    padding: 25px 40px 10px 40px;
  }
  label {
    display: block;
    text-align: center;
    color: #949292;
  }
  .groups input {
    background: none;
    color: #949292;
  }
  .groups {
    padding: 40px;
    font-weight: bold;
  }
  .input-group-addon {
    width: 70px;
    background-color: inherit;
    color: #949292;
    font-weight: bold;
  }
  .input-group {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// WeightVolumeCalculator.vue?675f46da